
const navItems = {
  home: { translateKey: "home", url: "/"},
  services: [
    { translateKey: "webApplicationDevelopment", url: "/services/web-application-development"},
    { translateKey: "mobileApplicationDevelopment", url: "/services/mobile-development"},
    { translateKey: "erpSolutions", url: "/services/erp-solutions"},
    { translateKey: "customizedSoftware", url: "/services/customized-software"}
  ],
  products: [
    { translateKey: "emrCliniVisita", url: "/products/emr-clini-visita"},
  ],
  contact: { translateKey: "contact", url: "/contact"},
};

export {
  navItems,
}
